import React, { useEffect, useRef } from 'react';
import type { ChatMessage } from '../types/chat';
import Message from './Message';

type ChatBoxProps = {
  messages: ChatMessage[];
  isLoading: boolean;
};

const ChatBox: React.FC<ChatBoxProps> = ({ messages, isLoading }) => {
  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isLoading]);

  return (
    <div className="flex-1 overflow-y-auto px-4 py-6 space-y-4">
      {messages.length === 0 && (
        <div className="text-center text-slate-400 text-sm">
          Ask anything about stocks, markets, or companies.
        </div>
      )}
      {messages.map((message) => (
        <Message key={message.id} message={message} />
      ))}
      {isLoading && (
        <div className="text-slate-400 text-sm animate-pulse">AI is thinking...</div>
      )}
      <div ref={bottomRef} />
    </div>
  );
};

export default ChatBox;
